import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowBigDown: IconNode = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M9 3h6v11h4l-7 7-7-7h4z' }]],
];

export default ArrowBigDown;
